// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark theme styles for AntD Select */
.ant-select-dark .ant-select-selector {
  background-color: #2D3748 !important;
  border: 1px solid #4A5568 !important;
  color: white !important;
}

.ant-select-dark .ant-select-selection-placeholder {
  color: #A0AEC0 !important;
}

.ant-select-dark .ant-select-selection-item {
  background-color: #4A5568 !important;
  color: white !important;
}

.ant-select-dropdown {
  background-color: #1A202C !important;
  color: white !important;
}

.ant-select-item-option {
  color: white !important;
}

.ant-select-item-option-active {
  background-color: #2C5282 !important;
}

.ant-select-item-option-selected {
  background-color: #2B6CB0 !important;
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/admin/analytics/index.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB","sourcesContent":["/* Dark theme styles for AntD Select */\n.ant-select-dark .ant-select-selector {\n  background-color: #2D3748 !important;\n  border: 1px solid #4A5568 !important;\n  color: white !important;\n}\n\n.ant-select-dark .ant-select-selection-placeholder {\n  color: #A0AEC0 !important;\n}\n\n.ant-select-dark .ant-select-selection-item {\n  background-color: #4A5568 !important;\n  color: white !important;\n}\n\n.ant-select-dropdown {\n  background-color: #1A202C !important;\n  color: white !important;\n}\n\n.ant-select-item-option {\n  color: white !important;\n}\n\n.ant-select-item-option-active {\n  background-color: #2C5282 !important;\n}\n\n.ant-select-item-option-selected {\n  background-color: #2B6CB0 !important;\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
